export default __webpack_public_path__ + "images/assets/0d292aefd372783ef71b2cb0d1924dd0.svg";